import React from 'react';
import { TextField, MenuItem } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { NONE_OPTION_VALUE } from '../../constants';
import { SelectOption } from './types';

interface SearchableSelectFieldProps {
  label: string;
  value: string;
  options: SelectOption[];
  onChange: (value: string) => void;
  disabled?: boolean;
  loading?: boolean;
  error?: boolean;
  helperText?: string;
}

export function SearchableSelectField({
  label,
  value,
  options,
  onChange,
  disabled = false,
  loading = false,
  error,
  helperText,
}: SearchableSelectFieldProps) {
  const noneOption = options.find(option => option.value === NONE_OPTION_VALUE);
  const selectedOption =
    options.find(option => option.value === value) ?? noneOption ?? null;

  return (
    <Autocomplete
      options={options}
      value={selectedOption}
      disabled={disabled}
      loading={loading}
      onChange={(_, option) =>
        onChange(option?.value ?? noneOption?.value ?? NONE_OPTION_VALUE)
      }
      getOptionLabel={option => option.label}
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
}

interface SimpleSelectFieldProps {
  label: string;
  value: string;
  options: SelectOption[];
  onChange: (value: string) => void;
  disabled?: boolean;
}

export function SimpleSelectField({
  label,
  value,
  options,
  onChange,
  disabled = false,
}: SimpleSelectFieldProps) {
  return (
    <TextField
      select
      label={label}
      variant="outlined"
      fullWidth
      disabled={disabled}
      value={value}
      onChange={event => onChange(event.target.value)}
      InputLabelProps={{ shrink: true }}
    >
      {options.map(option => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
